export default "__VITE_ASSET__8OjjzAvr__"